import React, { Component, PureComponent } from "react";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import { connect, getIn } from "formik";
import PropertyField from "./PropertyField";

class PropertyGridItem extends PureComponent {
  render = () => {
    const {
      fieldInfo,
      shouldHide,
      field = {},
      name,
      disabled: disabledSection
    } = this.props;

    if (shouldHide) return null;
    const {
      hidden,
      xs,
      sm,
      md,
      lg,
      xl,
      box = {},
      disabled,
      gridItemStyle = { alignSelf: "flex-start" },
      ...rest
    } = fieldInfo;

    const dis =
      disabledSection !== undefined ? disabledSection || disabled : disabled;

    return (
      <Grid item xs={xs} sm={sm} md={md} lg={lg} xl={xl} style={gridItemStyle}>
        <Box {...field} {...box}>
          <PropertyField name={name} disabled={dis} {...rest} />
        </Box>
      </Grid>
    );
  };
}

const PropertyGrid = connect(
  class PropertyGrid extends Component {
    shouldComponentUpdate = nextProps =>
      nextProps.fieldInfo !== this.props.fieldInfo ||
      nextProps.layout !== this.props.layout ||
      nextProps.formik.status !== this.props.formik.status ||
      nextProps.formik.values !== this.props.formik.values ||
      nextProps.formik.errors !== this.props.formik.errors ||
      nextProps.formik.touched !== this.props.formik.touched ||
      nextProps.formik.isSubmitting !== this.props.formik.isSubmitting ||
      nextProps.formik.isValidating !== this.props.formik.isValidating;

    processLayouts = list =>
      list
        ? typeof list === "string" || list instanceof String
          ? this.processLayout(list)
          : list.map(this.processLayout)
        : null;

    processLayout = name => {
      if (Array.isArray(name)) {
        return (
          <Grid container key={name} alignItems="center">
            {this.processLayouts(name)}
          </Grid>
        );
      }

      if (typeof name === "string" || name instanceof String) {
        const fieldInfo = (this.props.fieldInfo &&
          this.props.fieldInfo[name]) || { label: name };

        const prefixedName = this.props.prefix
          ? this.props.prefix + "." + name
          : name;

        const values = this.props.prefix
          ? getIn(this.props.formik.values, this.props.prefix)
          : this.props.formik.values;

        let shouldHide = false;
        if (fieldInfo.hidden !== undefined)
          shouldHide = fieldInfo.hidden(
            values,
            this.props.formik,
            this.props.prefix
          );

        return (
          <PropertyGridItem
            key={prefixedName}
            fieldInfo={fieldInfo}
            shouldHide={shouldHide}
            field={this.props.field}
            name={prefixedName}
            disabled={this.props.disabled}
          />
        );
      }

      return null;
    };

    render = () => this.processLayouts(this.props.layout);
  }
);

export default PropertyGrid;
